<template>
  <div class="flex">
    <vs-input
      label-placeholder="Name"
      v-model="data.name"
      class="mr-3"
    />
    <vs-input
      label-placeholder="Address"
      type="tel"
      v-model="data.address"
    />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          name: '',
          address: '',
          verified: false
        }
      }
    }
  },
  data () {
    return {
      edit: true
    }
  }
}
</script>
